import { Link } from "@tanstack/react-router";

const NOT_FOUND_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Advisory Services" },
  { to: "/blog", label: "Blogs" },
  { to: "/contact", label: "Contact" },
] as const;

export function NotFoundPage() {
  return (
    <div
      className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-brand-ink px-6 py-24 [contain:layout] [content-visibility:auto] [contain-intrinsic-size:800px]"
    >
      <meta name="robots" content="noindex, follow" />
      <div className="max-w-xl text-center">
        <p className="font-sans text-sm font-medium uppercase tracking-[0.15em] text-brand-primary min-h-[20px]">
          Error 404
        </p>
        <h1 className="mt-6 font-serif text-5xl leading-[1.05] tracking-tight text-brand-ivory md:text-6xl lg:text-7xl min-h-[3.5rem] md:min-h-[4rem] lg:min-h-[5rem]">
          Page Not Found
        </h1>
        <p className="mt-6 font-sans text-lg leading-relaxed text-brand-sand md:text-xl min-h-[3.5rem]">
          The resource you are looking for does not exist or has been moved.
        </p>
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="inline-flex min-h-[52px] items-center justify-center rounded-full bg-brand-primary px-8 py-4 font-sans text-sm font-medium uppercase tracking-[0.15em] text-brand-ink transition-colors duration-200 hover:bg-brand-punch"
          >
            Return to Homepage
          </Link>
        </div>
        <nav aria-label="Helpful links" className="mt-8">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-sans text-sm text-brand-sand">
            {NOT_FOUND_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="inline-flex min-h-[48px] items-center underline underline-offset-4 hover:text-brand-ivory"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
